import { twMerge } from "tailwind-merge";

type PendingProps = {
  className?: string;
};

function Pending({ className = "" }: PendingProps) {
  return (
    <div className={twMerge("flex justify-center mb-2.5", className)}>
      {/*<Loader className="animate-spin h-10 w-10 text-fig-text-secondary" />*/}
      <span className="loader"></span>
    </div>
  );
}

export { Pending };
